import { useEffect, useRef } from 'react';
import toast from 'react-hot-toast';
import { useLocation, useNavigate } from 'react-router-dom';
import { useProductContext } from '../product/context/ProductContext.tsx';
import { ROUTE_NAME_OPTIONS } from '../utils/constants.ts';

const OrderConfirmation = () => {
  const { setShoppingCart } = useProductContext();

  const navigate = useNavigate();
  const location = useLocation();
  const hasShownToast = useRef(false);

  const query = new URLSearchParams(location.search);
  const status = query.get('status');

  useEffect(() => {
    // Solo ejecutar una vez cuando el componente se monta
    if (hasShownToast.current || !status) return;

    hasShownToast.current = true;

    if (status === 'approved' || status === 'pending') {
      localStorage.removeItem('shoppingCart');
      setShoppingCart({ items: [], totalItems: 0, totalPrice: 0 });
    }

    // Usar setTimeout para asegurar que el toast se muestre correctamente
    const showToast = () => {
      if (status === 'approved') {
        toast.success('✅ Tu pedido fue confirmado con éxito.', {
          duration: 4000,
          position: 'top-center',
          id: 'order-confirmation', // ID único para prevenir duplicados
        });
      } else if (status === 'pending') {
        toast(
          '⏳ Tu pago está pendiente. Te notificaremos cuando se acredite.',
          {
            duration: 4000,
            position: 'top-center',
            id: 'order-pending',
          }
        );
      } else if (status === 'failure') {
        toast.error(
          '❌ Hubo un problema con el pago. Podés intentar nuevamente.',
          {
            duration: 4000,
            position: 'top-center',
            id: 'order-failure',
          }
        );
      }
    };

    // Pequeño delay para asegurar que el DOM esté listo
    const timeoutId = setTimeout(showToast, 100);

    return () => {
      clearTimeout(timeoutId);
    };
  }, []); // Sin dependencias para ejecutar solo una vez

  const renderContent = () => {
    switch (status) {
      case 'approved':
        return (
          <>
            <h2>🎉 ¡Gracias por tu compra!</h2>
            <p>Tu pedido fue confirmado con éxito.</p>
            <p>Vas a recibir un mail con los detalles.</p>
          </>
        );
      case 'pending':
        return (
          <>
            <h2>⏳ Pago pendiente</h2>
            <p>Tu pedido fue registrado pero el pago aún no fue confirmado.</p>
            <p>Te avisaremos por correo apenas se acredite.</p>
          </>
        );
      case 'failure':
        return (
          <>
            <h2>❌ Pago fallido</h2>
            <p>No pudimos procesar tu pago.</p>
            <p>Podés volver a intentarlo desde el carrito.</p>
          </>
        );
      default:
        return (
          <>
            <h2>🤔 Estado desconocido</h2>
            <p>No pudimos determinar el estado de tu pedido.</p>
          </>
        );
    }
  };

  return (
    <div style={{ padding: '20px', textAlign: 'center' }}>
      {renderContent()}
      <div className="flex-center gap-10">
        <button
          className="primary-button margin-top-20"
          onClick={() => navigate('/')}
        >
          Volver al inicio
        </button>
        <button
          className="primary-button margin-top-20"
          onClick={() => navigate(`/${ROUTE_NAME_OPTIONS.ORDERS}`)}
        >
          Ver mis pedidos
        </button>
      </div>
    </div>
  );
};

export default OrderConfirmation;
